import { all, fork, call, put, takeLatest } from 'redux-saga/effects'

import { constants } from '../../../modules/reports/financial/activeJobContractsReportActions'
import * as api from '../../../api/reports/financial/activeJobContractsReport'

function* activeJobContractsReportGetJobList(action) {
  try {
    const payload = yield call(api.getJobList, action.filters)
    yield put({ type: constants.ACTIVE_JOB_CONTRACTS_REPORT_GET_JOB_LIST.SUCCESS, payload })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.ACTIVE_JOB_CONTRACTS_REPORT_GET_JOB_LIST.FAILED,
      message: e.message || e
    })
  }
}

function* activeJobContractsReportGetOrganizationList(action) {
  try {
    const payload = yield call(api.getOrganizationList, action.filters)
    yield put({
      type: constants.ACTIVE_JOB_CONTRACTS_REPORT_GET_ORGANIZATION_LIST.SUCCESS,
      payload
    })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.ACTIVE_JOB_CONTRACTS_REPORT_GET_ORGANIZATION_LIST.FAILED,
      message: e.message || e
    })
  }
}

function* activeJobContractsReportGetFullReport(action) {
  try {
    const payload = yield call(api.getFullReport, action.filters)
    yield put({ type: constants.ACTIVE_JOB_CONTRACTS_REPORT_GET_FULL_REPORT.SUCCESS, payload })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.ACTIVE_JOB_CONTRACTS_REPORT_GET_FULL_REPORT.FAILED,
      message: e.message || e
    })
  }
}

/**
 * Saga
 */
function* watchActiveJobContractsReportGetJobList() {
  yield takeLatest(
    constants.ACTIVE_JOB_CONTRACTS_REPORT_GET_JOB_LIST.ACTION,
    activeJobContractsReportGetJobList
  )
}

function* watchActiveJobContractsReportGetOrganizationList() {
  yield takeLatest(
    constants.ACTIVE_JOB_CONTRACTS_REPORT_GET_ORGANIZATION_LIST.ACTION,
    activeJobContractsReportGetOrganizationList
  )
}

function* watchActiveJobContractsReportGetFullReport() {
  yield takeLatest(
    constants.ACTIVE_JOB_CONTRACTS_REPORT_GET_FULL_REPORT.ACTION,
    activeJobContractsReportGetFullReport
  )
}

/**
 * Export the root saga by forking all available sagas.
 */
export function* rootSaga() {
  // add more sagas here
  yield all([
    fork(watchActiveJobContractsReportGetJobList),
    fork(watchActiveJobContractsReportGetOrganizationList),
    fork(watchActiveJobContractsReportGetFullReport)
  ])
}



// WEBPACK FOOTER //
// ./src/redux/sagas/reports/financial/activeJobContractsReportSaga.js